import { render, staticRenderFns } from "./PrivacyXiaoMi.vue?vue&type=template&id=5f8a1148&scoped=true"
import script from "./PrivacyXiaoMi.vue?vue&type=script&lang=js"
export * from "./PrivacyXiaoMi.vue?vue&type=script&lang=js"
import style0 from "./PrivacyXiaoMi.vue?vue&type=style&index=0&id=5f8a1148&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f8a1148",
  null
  
)

export default component.exports